import * as React from "react";
import { VacuumAlloy } from "../core/alloy-types";

require("../../styles/shared-styles.scss");

interface VacuumTableRowProps {
  product: VacuumAlloy;
}

export class VacuumTableRowUI extends React.PureComponent<
  VacuumTableRowProps,
  {}
> {
  static counter = 0;

  render() {
    const p = this.props.product;

    let tableHeaderClassNames = "table-row";

    let fullRow = (
      <div className={tableHeaderClassNames}>
        <div className="category-col">{placeholderIfEmpty(p.category, 24)}</div>
        <div className="cm-col">
          {placeholderIfEmpty(p.cannonMuskegonTitle, 12)}
        </div>
        <div className="ams-col">
          {placeholderIfEmpty(p.aerospaceMaterialSpecifications)}
        </div>
        <div className="pwa-col">
          {placeholderIfEmpty(p.prattAndWhitney, 7)}
        </div>
        <div className="ge-col">{placeholderIfEmpty(p.generalElectric, 7)}</div>
        <div className="rrp-col">{placeholderIfEmpty(p.rollsRoycePlc)}</div>
        <div className="rrc-col">{placeholderIfEmpty(p.rollsRoyceCorp, 7)}</div>
        <div className="honeywell-col">
          {placeholderIfEmpty(p.honeywell, 7)}
        </div>
        <div className="safran-col">{placeholderIfEmpty(p.safran)}</div>
        
        <div className="table-elemental-col">{contactIfEmpty(p.carbon)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.cobalt)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.chromium)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.tungsten)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.niobium)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.tantalum)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.titanium)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.aluminum)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.boron)}</div>
        <div className="table-elemental-col">
          {contactIfEmpty(p.zirconium)}
        </div>
        <div className="table-elemental-col">{contactIfEmpty(p.hafnium)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.iron)}</div>
        <div className="table-elemental-col">{contactIfEmpty(p.rhenium)}</div>
        <div className="density-metric-col">
          {placeholderIfEmpty(p.densityMetric)}
        </div>
        <div className="imperial-metric-col">
          {placeholderIfEmpty(p.densityImperial)}
        </div>
        <div className="physical-col">{placeholderIfEmpty(p.solidusF)}</div>
        <div className="physical-col">{placeholderIfEmpty(p.liquidousF)}</div>
        <div className="physical-col">{placeholderIfEmpty(p.solidusC)}</div>
        <div className="physical-col">{placeholderIfEmpty(p.liquidousC)}</div>
        <div className="other-col">
          {p.other}
        </div>
      </div>
    );

    return fullRow;
  }
}

const LENGTH = 9;

function placeholderIfEmpty(value: any, length: number = LENGTH) {
  if (!value) {
    return "-";
  } else {
    return value;
  }
}

function contactIfEmpty(value: number | null) {
  if (value != null) {
    return value;
  } else {
    return "Contact";
  }
}
